module.exports = __webpack_public_path__ + "img/web_lib_room_1.cb9e9bce.jpg";